import { ServiceResponseErrorCode } from "../enums/serviceResponseErrorCode";
import { ServiceResponseResult } from "../enums/serviceResponseResult";
import { ServiceResponse, ServiceResponseNoContent } from "../models/serviceResponse";
import { ValidationError } from "../models/validationError";

class ServiceResponseFactory {

    /// <summary>Create a ServiceResponse for a request which completed successfully, and has content to return.</summary>
    public static SuccessfulResponse<T>(content: T): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(content);
        return serviceResponse;
    }

    /// <summary>Create a Failed ServiceResponse using the supplied error code.</summary>
    public static FailedResponse<T>(errorCode: ServiceResponseErrorCode, errorMessage: string): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(errorCode, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse where the request has failed due to a system fault such as a timeout, serialisation error, etc.</summary>
    public static FailedSystemErrorResponse<T>(errorMessage: string): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.SystemError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because a requested resource could not be found.</summary>
    public static FailedNotFoundResponse<T>(errorMessage: string = "Resource not found."): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.NotFound, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because a requested to create a resource failed due to a conflict (such as a duplicate Id).</summary>
    public static FailedConflictResponse<T>(errorMessage: string = "Resource already exists."): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.Conflict, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because the called was not authorized.</summary>
    public static FailedAuthorizationResponse<T>(errorMessage: string = "ermission was denied to complete request."): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.AuthorizationError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because the called was not authorized.</summary>
    public static FailedAuthenticationResponse<T>(errorMessage: string = "ermission was denied to complete request."): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.AuthenticationError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed becuase of input from the caller.</summary>
    public static FailedValidationResponse<T>(validationErrors: ValidationError[], errorMessage: string = "There was an issue with some of the request data."): ServiceResponse<T> {
        const serviceResponse = new ServiceResponse<T>(ServiceResponseErrorCode.ValidationError, errorMessage, validationErrors);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed becuase of input from the caller.</summary>
    public static FailedValidationResponseSingle<T>(fieldName: string, errorCode: string, errorMessage: string = "There was an issue with some of the request data."): ServiceResponse<T> {

        const validationError = new ValidationError();
        validationError.fieldName = fieldName;
        validationError.errorCode = String(errorCode);
        validationError.errorMessage = errorMessage

        return this.FailedValidationResponse([validationError], errorMessage);
    }

    /// <summary>Create a ServiceResponse for a request which completed successfully, and has content to return.</summary>
    public static SuccessfulResponseNoContent(): ServiceResponseNoContent {
        return new ServiceResponseNoContent();
        // const serviceResponse = new ServiceResponseNoContent();
        // return serviceResponse;
    }

    /// <summary>Create a Failed ServiceResponse using the supplied error code.</summary>
    public static FailedResponseNoContent(errorCode: ServiceResponseErrorCode, errorMessage: string): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(errorCode, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse where the request has failed due to a system fault such as a timeout, serialisation error, etc.</summary>
    public static FailedSystemErrorResponseNoContent(errorMessage: string): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.SystemError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because a requested resource could not be found.</summary>
    public static FailedNotFoundResponseNoContent(errorMessage: string = "Resource not found."): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.NotFound, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because a requested to create a resource failed due to a conflict (such as a duplicate Id).</summary>
    public static FailedConflictResponseNoContent(errorMessage: string = "Resource already exists."): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.Conflict, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because the called was not authorized.</summary>
    public static FailedAuthorizationResponseNoContent(errorMessage: string = "ermission was denied to complete request."): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.AuthorizationError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed because the called was not authorized.</summary>
    public static FailedAuthenticationResponseNoContent(errorMessage: string = "ermission was denied to complete request."): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.AuthenticationError, errorMessage);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed becuase of input from the caller.</summary>
    public static FailedValidationResponseNoContent(validationErrors: ValidationError[], errorMessage: string = "There was an issue with some of the request data."): ServiceResponseNoContent {
        const serviceResponse = new ServiceResponseNoContent(ServiceResponseErrorCode.ValidationError, errorMessage, validationErrors);
        return serviceResponse;
    }

    /// <summary>Create a ServiceResponse for a request which failed becuase of input from the caller.</summary>
    public static FailedValidationResponseSingleNoContent(fieldName: string, errorCode: string, errorMessage: string = "There was an issue with some of the request data."): ServiceResponseNoContent {

        const validationError = new ValidationError();
        validationError.fieldName = fieldName;
        validationError.errorCode = errorCode;
        validationError.errorMessage = errorMessage

        return this.FailedValidationResponseNoContent([validationError], errorMessage);
    }

}

export { ServiceResponseFactory }